<template>
  <div class="inner-texts-b-1">
    <h1>
      When did
      <br />you change
      <br />your filter?
    </h1>
    <datetime
      class="date-theme-app-like"
      :max-datetime="max"
      style="height: 0; overflow: hidden;"
      ref="dateTime"
      v-model="date"
    ></datetime>
    <h3 @click="$refs.dateTime.open($event)">{{formattedDate}}</h3>
    <a @click.prevent="start" href="#" class="start-btn">Start</a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      date: new Date().toISOString(),
      max: new Date().toISOString()
    }
  },
  methods: {
    start() {
      this.$emit('next', new Date(this.date).getTime())
    }
  },
  computed: {
    formattedDate() {
      return new Date(this.date).toDateString()
    }
  }
}
</script>

<style>
.date-theme-app-like .vdatetime-popup__header,
.date-theme-app-like .vdatetime-calendar__month__day--selected > span > span,
.date-theme-app-like .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #07313c;
}

.date-theme-app-like .vdatetime-year-picker__item--selected,
.date-theme-app-like .vdatetime-time-picker__item--selected,
.date-theme-app-like .vdatetime-popup__actions__button {
  color: #07313c;
}
</style>